// extracted by mini-css-extract-plugin
export default {"logout":"PUYM6bT6"};